import {Side, Turn} from './index.h'

export class Transition {
  from: Side
  to: Side
  turn: Turn
  constructor({from, to, turn}: {from: Side; to: Side; turn: Turn}) {
    this.from = from
    this.to = to
    this.turn = turn
  }
}
